module.exports = __webpack_public_path__ + "static/media/7_DSC_8390.d39b3238.webp";